import { render } from "./Rewards.vue?vue&type=template&id=3a7d91b6&scoped=true&ts=true"
import script from "./Rewards.vue?vue&type=script&lang=ts"
export * from "./Rewards.vue?vue&type=script&lang=ts"

import "./Rewards.vue?vue&type=style&index=0&id=3a7d91b6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7d91b6"]])

export default __exports__